import { SetPasswordModule } from '@modules';

export const SetPassWord = () => <SetPasswordModule />;
